export const RENAME_PROPOSAL_FORM_ID = 'rename-proposal-form';
